import { Blue, Gray, White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '24px',
  minWidth: '256px'
});

export const mainContainer = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  padding: '8px',
  height: '336px',
  backgroundColor: Gray.Gray90,
  borderColor: 'transparent',
  borderWidth: '4px',
  borderStyle: 'solid',
  borderRadius: '8px'
});
export const mainContainerFocused = css({
  borderColor: Blue.Blue60
});

export const mainContentContainer = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexGrow: 1
});

export const bottomContainer = css({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '8px'
});

export const matching = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '48px',
  backgroundColor: Gray.Gray70,
  borderRadius: '4px',
  color: White.White10,
  fontSize: '20px',
  fontWeight: 500
});
export const matchingFocused = css({
  backgroundColor: Blue.Blue60
});

export const description = css({
  color: Gray.Gray60,
  fontSize: '20px',
  fontWeight: 500
});
export const descriptionFocused = css({
  color: White.White10
});
